import type { Ref } from 'vue'

const sameValueAs = (
  form: Ref<any>,
  key: string,
  confirmKey: string
): boolean => {
  return form.value[key] === form.value[confirmKey]
}

export default sameValueAs
